import { render, staticRenderFns } from "./list_zen_stars_request_list_component.vue?vue&type=template&id=0baaa2de&scoped=true"
import script from "./list_zen_stars_request_list_component.vue?vue&type=script&lang=js"
export * from "./list_zen_stars_request_list_component.vue?vue&type=script&lang=js"
import style0 from "./list_zen_stars_request_list_component.vue?vue&type=style&index=0&id=0baaa2de&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baaa2de",
  null
  
)

export default component.exports